import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';
import { EmptyStateIconCircle, EmptyStateLine, EmptyStateLines, EmptyStateTitle, EmptyStateWrap } from './styles';
import { UPEmptyStateProps } from './types';

const UPEmptyState = (props: UPEmptyStateProps): JSX.Element => {
  const { messageKey, icon, testId } = props;
  const [t] = useTranslation();

  return (
    <EmptyStateWrap data-testid={testId}>
      <EmptyStateIconCircle>{icon}</EmptyStateIconCircle>
      <EmptyStateTitle>{t(messageKey)}</EmptyStateTitle>
      <EmptyStateLines aria-hidden>
        <EmptyStateLine lineWidth={92} />
        <EmptyStateLine lineWidth={56} />
      </EmptyStateLines>
    </EmptyStateWrap>
  );
};

UPEmptyState.defaultProps = {
  icon: <InfoOutlinedIcon />,
  testId: undefined,
};

export default UPEmptyState;
